(function () {
  'use strict';

  function initGallery() {
    document.querySelectorAll('.cb-product-gallery').forEach(gallery => {
      const list = gallery.querySelector('.cb-product-gallery-list');
      const dots = gallery.querySelectorAll('.cb-gallery-dot');
      if (!list || !dots.length) return;

      list.addEventListener('scroll', () => {
        const idx = Math.round(list.scrollLeft / list.offsetWidth);
        dots.forEach((d, i) => d.classList.toggle('active', i === idx));
      }, { passive: true });

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          list.scrollTo({ left: i * list.offsetWidth, behavior: 'smooth' });
        });
      });
    });
  }

  function getVariants() {
    const el = document.getElementById('cb-product-variants');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  }

  function getCurrency() {
    const el = document.getElementById('cb-product-currency');
    return el ? el.textContent.trim() : 'EUR';
  }

  function fmt(n, currency) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(n / 100);
  }

  function updateUI(variant) {
    if (!variant) return;
    const currency = getCurrency();

    document.querySelectorAll('[data-cart-price]').forEach(el => {
      el.textContent = fmt(variant.price, currency);
    });
    document.querySelectorAll('[data-sticky-price]').forEach(el => {
      el.textContent = fmt(variant.price, currency);
    });

    const compareEl = document.querySelector('[data-compare-price]');
    if (compareEl) {
      const show = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEl.textContent = show ? fmt(variant.compare_at_price, currency) : '';
      compareEl.hidden = !show;
    }

    const variantInput = document.querySelector('form[action="/cart/add"] [name="id"]');
    if (variantInput) variantInput.value = variant.id;

    const discountBadge = document.querySelector('[data-discount-badge]');
    if (discountBadge) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        discountBadge.textContent = '-' + pct + '%';
        discountBadge.hidden = false;
      } else {
        discountBadge.hidden = true;
      }
    }

    document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
      btn.disabled = !variant.available;
      btn.querySelector('[data-add-label]').textContent = variant.available
        ? (btn.dataset.addText || 'Ajouter au panier')
        : 'Épuisé';
    });

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function findVariant(selectedOptions) {
    return getVariants().find(v =>
      v.options.every((opt, i) => !selectedOptions[i] || opt === selectedOptions[i])
    ) || null;
  }

  function readSelectedOptions(picker) {
    const opts = [];
    for (let i = 0; i < 3; i++) {
      const active = picker.querySelector(`.cb-swatch[data-option-index="${i}"].active`);
      if (active) opts[i] = active.dataset.value;
    }
    return opts;
  }

  function initVariantPicker() {
    document.querySelectorAll('.cb-variant-picker').forEach(picker => {
      picker.querySelectorAll('.cb-swatch').forEach(swatch => {
        swatch.addEventListener('click', () => {
          const idx = swatch.dataset.optionIndex;
          picker.querySelectorAll(`.cb-swatch[data-option-index="${idx}"]`)
            .forEach(s => s.classList.remove('active'));
          swatch.classList.add('active');
          const variant = findVariant(readSelectedOptions(picker));
          if (variant) updateUI(variant);
        });
      });
    });
  }

  function initQtySelector() {
    document.querySelectorAll('.cb-qty-wrap').forEach(wrap => {
      const input = wrap.querySelector('.cb-qty-input');
      if (!input) return;
      wrap.querySelectorAll('.cb-qty-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const val = parseInt(input.value, 10) || 1;
          if (btn.dataset.qtyAction === 'minus') input.value = Math.max(1, val - 1);
          if (btn.dataset.qtyAction === 'plus')  input.value = Math.min(99, val + 1);
        });
      });
    });
  }

  function initStickyBar() {
    const bar = document.querySelector('.cb-sticky-bar');
    const mainCta = document.querySelector('[data-main-cta]');
    if (!bar || !mainCta) return;

    const stickyBtn = bar.querySelector('[data-sticky-add-to-cart]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const submitBtn = document.querySelector('form[action="/cart/add"] [type="submit"]');
        if (submitBtn) submitBtn.click();
      });
    }

    function updateBar() {
      const rect = mainCta.getBoundingClientRect();
      const ctaVisible = rect.top < window.innerHeight && rect.bottom > 0;
      bar.classList.toggle('cb-sticky-bar--visible', !ctaVisible);
    }

    window.addEventListener('scroll', updateBar, { passive: true });
    updateBar();
  }

  function initRecommendations() {
    const section = document.querySelector('.cb-recommendations[data-url]');
    if (!section) return;
    fetch(section.dataset.url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = doc.querySelector('.cb-recommendations-grid');
        if (grid) {
          const current = section.querySelector('.cb-recommendations-grid');
          if (current) current.replaceWith(grid);
        }
      })
      .catch(() => {});
  }

  function init() {
    initGallery();
    initVariantPicker();
    initQtySelector();
    initStickyBar();
    initRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
